module.exports = __webpack_public_path__ + "img/next-track-button-g.24339fa1.svg";